let defaultOption = "Select..."

const getDropdownValue = (options, value) => {
  return findColumnName(options, value, defaultOption);
};

const findColumnName = (options, value, defaultValue) => {
  if (options === null || value === null) return defaultValue ?? null;

  for (const option of options) {
    if (option.toUpperCase() === value.toUpperCase()) {
      return option;
    }
  }
      
  return defaultValue ?? null;
};

export { getDropdownValue, findColumnName };


/*
Note: Some things to consider here: value should really be values since we want to match multiple possible values in the option list
for example, Latitude, Lat, Long, Longitude, etc...
*/